export interface SavingsGoal {
  id: number;
  name: string;
  description: string;
  amount: number;
  timeFrame: number;
  icon: string;
}

export interface SavingsStrategy {
  id: number;
  name: string;
  description: string;
  type: 'fixed' | 'percentage';
  value: number;
  icon: string;
}

export interface SavingsPeriod {
  month: number;
  plannedAmount: number;
  actualAmount: number;
  completed: boolean;
}

export interface SavingsStats {
  goalCompleted: boolean;
  hasSmartGoal: boolean;
  hasStrategy: boolean;
  consistentSavings: boolean;
}

export interface SavingsGameState {
  gameStarted: boolean;
  isGameOver: boolean;
  timeLeft: number;
  selectedGoal: SavingsGoal | null;
  selectedStrategy: SavingsStrategy | null;
  periods: SavingsPeriod[];
  totalSaved: number;
  savedAmount: number; 
  score: number; 
  cerebrixEarned?: number; 
  stats: SavingsStats;
}

export const SAVINGS_GOALS: SavingsGoal[] = [
  {
    id: 1,
    name: "Mi Primera Bicicleta",
    description: "Ahorra para comprar una bicicleta nueva",
    amount: 200,
    timeFrame: 6,
    icon: "🚲"
  },
  {
    id: 2,
    name: "Consola de Videojuegos",
    description: "Consigue la última consola de videojuegos",
    amount: 400,
    timeFrame: 6,
    icon: "🎮"
  },
  {
    id: 3,
    name: "Tablet para Estudiar",
    description: "Una tablet para tomar notas y leer libros",
    amount: 300,
    timeFrame: 6,
    icon: "📱"
  },
  {
    id: 4,
    name: "Fondo de Emergencia",
    description: "Ten un respaldo para imprevistos",
    amount: 250,
    timeFrame: 6,
    icon: "🏦"
  }
];

export const SAVINGS_STRATEGIES: SavingsStrategy[] = [
  {
    id: 1,
    name: "Ahorro Fijo",
    description: "Guarda una cantidad fija cada mes",
    type: "fixed",
    value: 40,
    icon: "💰"
  },
  {
    id: 2,
    name: "Porcentaje de Mesada",
    description: "Ahorra un porcentaje de tu mesada",
    type: "percentage",
    value: 20,
    icon: "📊"
  },
  {
    id: 3,
    name: "Ahorro Agresivo",
    description: "Maximiza tus ahorros mensuales",
    type: "fixed",
    value: 60,
    icon: "🎯"
  },
  {
    id: 4,
    name: "Ahorro Flexible",
    description: "Adapta tus ahorros a tus ingresos",
    type: "percentage",
    value: 30,
    icon: "⚖️"
  }
];

export const INITIAL_STATE: SavingsGameState = {
  gameStarted: false,
  isGameOver: false,
  timeLeft: 300, 
  selectedGoal: null,
  selectedStrategy: null,
  periods: [],
  totalSaved: 0,
  savedAmount: 0,
  score: 0,
  stats: {
    goalCompleted: false,
    hasSmartGoal: false,
    hasStrategy: false,
    consistentSavings: false
  }
};
